<template>
  <nav class="navigation white--text">
    <div class="container py-0">
      <ul class="navigation__list row">
        <li class="navigation__item col-auto pr-6" v-if="!$route.name.includes('login')">
          <router-link
            v-if="!printerUrl"
            :to="{
              name: this.$route.params.code? 'customer.printers' :'printers',
            }"
          >
            Přehled tiskáren
          </router-link>
          <a
            class="router-link-active"
            @click.prevent="reload"
            href="#"
            v-else
          >
            Přehled tiskáren
          </a>
        </li>
        <li class="navigation__item col-auto pr-6" style="height: 56px" v-else></li>
        <li v-if="!this.$route.params.code" class="navigation__item col-3 ml-auto py-0">
          <div v-if="accessToken" class="login col py-1 px-2">
            <v-row class="no-gutters">
              <v-col cols="12" class="text-truncate">
                <v-icon color="white" class="mt-n1 mr-1">mdi-account-outline</v-icon>
                {{ userName }}
              </v-col>
              <v-col cols="auto" class="ml-auto">
                <a href="#" @click.prevent="logout">
                  Odhlásit
                </a>
              </v-col>
            </v-row>
          </div>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'TheNavigation',
  computed: {
    ...mapState({
      accessToken: (state) => state.auth.accessToken,
      userName: (state) => (state.auth.user ? state.auth.user : ''),
    }),
    printerUrl() {
      return window.location.pathname.includes(this.$route.path) && this.$route.name === 'printers';
    },
  },
  methods: {
    reload() {
      window.location.reload();
    },
    logout() {
      this.$store.dispatch('auth/logout');
    },
  },
};
</script>

<style lang="scss">
@import '../scss/utilities/px-to-rem';

.v-application {
  .navigation {
    background: #cc0102;
    margin-bottom: 25px;
  }

  .navigation__list {
    padding: 0;
    list-style: none;

    .login a {
      @include rem(font-size, 14px);
      font-weight: 300;
      text-decoration: underline;

      &:hover {
        text-decoration: none;
        color: #fff;
      }
    }
  }

  .navigation__item {
    position: relative;
    align-items: center;
    display: flex;
  }

  .navigation__item a {
    @include rem(font-size, 20px);
    color: #fff;
    text-decoration: none;

    &:hover {
      color: #eee;
    }
  }

  .navigation__item .router-link-active {
    color: #fff;

    &::before {
      content: '';
      position: absolute;
      top: 100%;
      left: 50%;
      transform: translateX(-50%);
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 8px 10px 0 10px;
      border-color: #cc0102 transparent transparent transparent;
    }
  }
}

.login {
  color: #fff;
  background: #da0102;
  height: 100%;
  border-left: 1px rgba(0,0,0,0.1) solid;
  border-right: 1px rgba(0,0,0,0.1) solid;
}
</style>
